/**
 * =============================================================================
 * countdown-manager.js
 * =============================================================================
 * Manage / update countdowns
 * =============================================================================
 */

import { differenceInDays, differenceInHours, differenceInMinutes, 
  differenceInSeconds, subDays, subHours, subMinutes, isBefore } from 'date-fns' 

var CountdownManager = {
  intervals: {},

  init: function(){
    this.intervals = {};
    document.querySelectorAll(".countdown").forEach(element => {
      let end = element.dataset.countdownEnd;
      let id = element.dataset.countdown;
      this.intervals[id] = setInterval(this.update.bind(this, element), 1000);
      this.update(element);
      console.log("[C-M] Set interval for countdown", element);
    });
  },

  update: function(element) {
    let id = element.dataset.countdown;
    let now = new Date();
    let relativeEnd = new Date(element.dataset.countdownEnd * 1000);
    let format = element.dataset.countdownFormat;

    if(format == "d-h-m-s"){
      let diffDays = differenceInDays(relativeEnd, now);
      element.querySelector(".countdown-days").innerText = diffDays;
      relativeEnd = subDays(relativeEnd, diffDays);
    }

    let diffHours = differenceInHours(relativeEnd, now);
    element.querySelector(".countdown-hours").innerText = diffHours;
    relativeEnd = subHours(relativeEnd, diffHours);

    let diffMins = differenceInMinutes(relativeEnd, now);
    element.querySelector(".countdown-minutes").innerText = ("00" + diffMins).slice(-2);
    relativeEnd = subMinutes(relativeEnd, diffMins);

    let diffSecs = differenceInSeconds(relativeEnd, now);
    element.querySelector(".countdown-seconds").innerText = ("00" + diffSecs).slice(-2);

    if(isBefore(relativeEnd, now)){
      element.parentNode.removeChild(element);
      clearInterval(this.intervals[id]);
    }
  }
};

export default CountdownManager;